export default {
  RESET_ADDRESS_STATE: 'RESET_ADDRESS_STATE',
  SET_IS_ADDING_ADDRESS: 'SET_IS_ADDING_ADDRESS',
  SET_IS_EDITING_ADDRESS: 'SET_IS_EDITING_ADDRESS',
};
